export { Components, JSX } from './components';
import { setAssetPath } from '@stencil/core';

setAssetPath((document.currentScript as HTMLScriptElement).src);
